import { CREATE_DATA_OBJECT, RECEIVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type IBrief, type ITenantConfiguration, tenantConfigurationProperties, tenantConfigurationsManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { isDataObject } from '@/services/data-object-helper';

import { BRIEF_MODULE } from '../brief-module';
import { type ITenantConfigurationState } from './types';

export const RETRIEVE_OR_CREATE_TENANT_CONFIG = 'retrieveOrCreateTenantConfig';
export const RETRIEVE_TENANT_CONFIG = 'retrieveTenantConfig';

export const actions: ActionTree<ITenantConfigurationState, unknown> = {
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: ITenantConfiguration[] }) {
        const tenantConfigurations: ITenantConfiguration[] = [];
        const briefs: IBrief[] = [];

        dataObjectList.forEach((tenantConfiguration) => {
            let _tenantConfiguration = Object.assign({}, tenantConfiguration);

            // Extract Brief object if necessary
            if (isDataObject<IBrief>(tenantConfiguration.defaultBrief)) {
                const brief = Object.assign({}, tenantConfiguration.defaultBrief);
                _tenantConfiguration = Object.assign({}, tenantConfiguration, { defaultBrief: brief.dobjId });
                briefs.push(brief);
            }

            tenantConfigurations.push(_tenantConfiguration);
        });

        if (tenantConfigurations.length > 0) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: tenantConfigurations });
        }
        if (briefs.length > 0) {
            void context.dispatch(`${BRIEF_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: briefs }, { root: true });
        }
    },

    async [RETRIEVE_OR_CREATE_TENANT_CONFIG](context) {
        let tenantConfig = null;
        try {
            tenantConfig = await tenantConfigurationsManager.getTenantConfig();
        } catch (error) {
            // If the error is 404, we'll ignore it, as this mean the object doesn't exist yet, so we need to create it
            if (error.status !== 404) {
                throw error;
            }
        }

        if (tenantConfig !== null) {
            await context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [tenantConfig] });
        } else {
            await context.dispatch(CREATE_DATA_OBJECT, {
                dataObjectList: [{ type: 'DEFAULT' }],
                properties: tenantConfigurationProperties.DEFAULT
            });
        }
    },

    async [RETRIEVE_TENANT_CONFIG](context) {
        const tenantConfig = await tenantConfigurationsManager.getTenantConfig();
        if (tenantConfig) {
            await context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [tenantConfig] });
        }
    }
};
